import { render, staticRenderFns } from "./refined_details.vue?vue&type=template&id=b520c9b0&scoped=true"
import script from "./refined_details.vue?vue&type=script&lang=js"
export * from "./refined_details.vue?vue&type=script&lang=js"
import style0 from "./refined_details.vue?vue&type=style&index=0&id=b520c9b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b520c9b0",
  null
  
)

export default component.exports